import { useRef, useState } from "react";

import { IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";

/*
 * 라벨이 끝쪽 아이콘(검색/지우기)을 파고드는 것을 막는다.
 * MUI outlined 라벨은 endAdornment 만큼 폭을 줄여 주지 않아서, 라벨이 길면 아이콘 위로 겹쳐 그려진다
 * (NPI Mapping 의 "Customer Hierarchy Code" 가 실제로 그랬다). 라벨 길이는 언어마다 달라
 * 폭을 키우는 것만으로는 못 막으므로 여기서 잘라 준다.
 *
 * 60px = 검색 아이콘 버튼(30) + 입력칸 오른쪽 패딩(14) + 라벨 왼쪽 오프셋(14) + 여유.
 * shrink 상태(값이 있거나 포커스 → 라벨이 테두리 위로 올라감)에는 아이콘과 겹칠 일이 없으니 제한하지 않는다
 * — 그래서 전체 라벨은 클릭하면 항상 볼 수 있다.
 */
const LABEL_NO_OVERLAP_SX = {
  "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
    maxWidth: "calc(100% - 60px)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const TextFieldSearch = ({ label, searchCode, retrieve, sx, ...others }) => {
  const { t } = useTranslation();

  const [clearIconOpen, setClearIconOpen] = useState(!isEmpty(searchCode.current));
  const searchInputRef = useRef();

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      retrieve();
    }
  }

  const onChangeSearchCode = (e) => {
    searchCode.current = e.target.value;
    setClearIconOpen(!isEmpty(searchCode.current));
  }

  const onClearSearchCode = () => {
    if (searchInputRef.current) {
      searchCode.current = "";
      searchInputRef.current.value = "";
      setClearIconOpen(false);
    }
  }

  return (
    <TextField
      inputRef={searchInputRef}
      label={t(label)}
      size="small"
      sx={{ width: 200, ...LABEL_NO_OVERLAP_SX, ...sx }}
      onKeyPress={handleKeyPress}
      onChange={onChangeSearchCode}
      defaultValue={searchCode.current}
      InputLabelProps={{ shrink: clearIconOpen || !isEmpty(searchCode.current) }}
      InputProps={{
        endAdornment:
          <InputAdornment position="end">
            <IconButton aria-label="search" size="small" color="default" onClick={onClearSearchCode}
              sx={{ display: clearIconOpen ? "" : "none", padding: "unset" }}>
              <ClearIcon className="text-field-clear" titleAccess="Clear" />
            </IconButton>
            <IconButton aria-label="search" size="small" onClick={retrieve}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
      }}
      {...others}
    />
  )
}

export default TextFieldSearch;